import { Base } from '@studiometa/js-toolkit';

/**
 * ProductRecommendations
 */
export default class StickyHeader extends Base {
  currentItem = null;
  /**
   * Component Configuration
   */
  static config = {
    name: 'StickyHeader',
    refs: ['items[]'],
  };

  /**
   *
   */
  mounted() {
    const observer = new IntersectionObserver(this.checkIntersection.bind(this), {
      threshold: 0.2,
    });

    const sections = document.querySelectorAll('main > [id^="shopify-section-template--"]');

    sections.forEach((target) => {
      observer.observe(target);
    });
  }

  /**
   * Check gallery intersection
   * @param  {object} entries
   * @returns {void}
   */
  checkIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const firstDescendantWithId = entry.target.querySelector('[id]');
        if (firstDescendantWithId) {
          const id = firstDescendantWithId.id;
          const matchingItem = this.$refs.items.find(
            (item) => item.getAttribute('href') === `#${id}`,
          );
          if (matchingItem) {
            matchingItem.classList.remove('btn-underline--reverse');
          }
        }
      } else {
        const firstDescendantWithId = entry.target.querySelector('[id]');
        if (firstDescendantWithId) {
          const id = firstDescendantWithId.id;
          const matchingItem = this.$refs.items.find(
            (item) => item.getAttribute('href') === `#${id}`,
          );
          if (matchingItem) {
            matchingItem.classList.add('btn-underline--reverse');
          }
        }
      }
    });
  }
}
